module.exports = {"OBJECT_PERMISSION_ALLOW":"ALLOW","OBJECT_PERMISSION_DENY":"DENY"}